var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { getObservableT } from "../Infra/i18next";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
const t = getObservableT("patients");
export class PatientConsentHowItWorksViewModel extends PatientConsentViewModel {
    constructor(container) {
        super(container);
        this.patientConsentUIManager = container.patientConsentUIManager;
    }
    get howItWorksFindRecordsText() {
        return this.isHealthWalletEnabled ? t("Find and Review Your Records") : t("Build and review your Unified Record");
    }
    get howItWorksTitle() {
        return t("How HealthEx Works");
    }
    get howItWorksSupportingText() {
        return t("This takes about five minutes.");
    }
    get howItWorksReviewRecordsText() {
        return t("Confirm and Complete");
    }
    get identityVerificationStepText() {
        return t("Verify Your Identity");
    }
    continue() {
        this.patientConsentUIManager.goToNextPage();
    }
}
__decorate([
    computed
], PatientConsentHowItWorksViewModel.prototype, "howItWorksFindRecordsText", null);
__decorate([
    computed
], PatientConsentHowItWorksViewModel.prototype, "howItWorksTitle", null);
__decorate([
    computed
], PatientConsentHowItWorksViewModel.prototype, "howItWorksSupportingText", null);
__decorate([
    computed
], PatientConsentHowItWorksViewModel.prototype, "howItWorksReviewRecordsText", null);
__decorate([
    computed
], PatientConsentHowItWorksViewModel.prototype, "identityVerificationStepText", null);
